import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
function NullData() {
     return (
          <>
               <div className="Null_data_box">
                    <div className="Null_data_inner_box">
                         <Spinner animation="border" variant="info" size="xl" />
                         {/* <Spinner animation="border" variant="info" role="status">
                              <span className="visually-hidden">Loading...</span>
                         </Spinner> */}
                    </div>
               </div>

          </>
     );
}
export default NullData;